app.service("PushEventAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		var service = {
			/**
			 * Polls the caller's practice and user channels for events newer than the cursors from the
			 * previous poll. Omit both cursors on the first poll of a session - the response comes back
			 * empty with freshly minted "now" cursors, so a client is never handed a backlog.
			 *
			 * Cursors are "<UTC ISO millis>#<8-char uuid>" and so must be encoded - an unencoded "#"
			 * would truncate the query string and silently turn every poll into a first poll.
			 */
			pollEvents: function (practiceCursor, userCursor, _practiceId) {
				let practiceId = _practiceId ? _practiceId : Session.practice.id;
				let params = [];
				if (practiceCursor) {
					params.push("practiceCursor=" + encodeURIComponent(practiceCursor));
				}
				if (userCursor) {
					params.push("userCursor=" + encodeURIComponent(userCursor));
				}
				let query = params.length ? "?" + params.join("&") : "";

				return $http({
					method: "GET",
					url: ENV.API + "/api/push-events" + query,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${practiceId}`,
					},
				});
			},
		};

		return service;
	},
]);
